import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { startCheckout } from "../lib/checkout";
import { TIERS } from "../data/tiers";

const slideUp = {
  initial: { y: 80, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: 80, opacity: 0 },
  transition: { duration: 0.35, ease: [0.16, 1, 0.3, 1] },
};

export const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          {...slideUp}
          className="lg:hidden fixed bottom-0 left-0 right-0 z-50 p-3 glass border-t border-[var(--border-strong)]"
          data-testid="sticky-mobile-cta"
        >
          <button
            onClick={() => startCheckout(TIERS.pro.lookupKey, setLoading)}
            disabled={loading}
            className="cta-primary w-full py-3.5 text-sm disabled:opacity-60"
            data-testid="sticky-mobile-checkout-btn"
          >
            {loading ? "REDIRECTING…" : "UNLOCK PRO — $199/MO"}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
